export function getLabelCountTotal(counts) {
  // Counts arrive serialized as a plain object (e.g. { total, validated, ... }).
  // Prefer `total`, then fall back to `validated`.
  if (!counts || typeof counts !== "object") return null;
  const total = Number(counts.total ?? counts.validated);
  return Number.isFinite(total) ? total : null;
}

